import styled from "styled-components";
import { Heading2 } from "../../typography/text";

export const SuccessIcon = styled.span`
    display: inherit;

    i {
        color: ${(props) => props.theme.colors.secondaryIcon} !important;
    }
`;

export const StyledIcon = styled.i<{
    size?: string;
    color?: string;
}>`
    text-decoration: none;
    background: transparent;
    color: ${(props) => props.color || `inherit`};
    font-size: ${(props) => props.size};
`;

export const IconTitleContainer = styled.div<{ uppercase?: boolean }>`
    i {
        font-size: 2.5em;
        color: ${(props) => props.theme.colors.text1};
    }

    label {
        color: ${(props) => props.theme.colors.text1};
        text-transform: uppercase;
        font-size: 12px;
    }

    ${Heading2} {
        display: flex;
        font-size: 12px;
        align-items: center;
        text-transform: ${(props) => (props.uppercase ? `uppercase` : `none`)};
        color: ${(props) => props.theme.colors.text1};
        font-weight: ${(props) => props.theme.fontWeightLight};
    }
`;
